export const INQUIRY_REQUEST = "INQUIRY_REQUEST";
export const INQUIRY_SUCCESS = "INQUIRY_SUCCESS";
export const INQUIRY_FAILURE = "INQUIRY_FAILURE";